import ready from 'document-ready';
import searchParams from './lib/searchQuery';
import { hofAddHomeScreen } from './lib/hofAddHomeScreen';

import Game from './components/Game';
import gtmInit from './components/gtm';
import hofCookie, { QS_PARAMS } from './lib/cookie-data';
import HofUser from './components/user';
import Dom from './components/dom';
import HofCanvas from './components/canvas';
import JqueryCode from './components/jquery-code';

ready(async () => {
	const hasSearch = searchParams.size > 0;

	if (hasSearch) {
		hofCookie.set(QS_PARAMS, searchParams.toString());
	}

	const hofUser = new HofUser();

	await hofUser.init();

	window.hofUser = hofUser;

	new HofCanvas(hofUser);
	new Dom();

	gtmInit();

	const game = new Game(hofUser);

	game.init();

	hofAddHomeScreen();

	(($) => new JqueryCode($))(jQuery);
});
